import styled from '@emotion/styled';

export const Wrapper = styled.div`
  & > :not(:last-child) {
    margin-bottom: 1rem;
  }
`;
